import React from "react";
import classNames from "classnames";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { usePreferences } from "@components/preferences";
import { useToggle } from "../utils";
import { ToggleArrow } from "../toggleArrow";
import { Props } from "./types";
import { Task } from "./task";
import { Checkbox } from "@common/checkbox";
import styles from "./styles.scss";
import { ScrollingText } from "@common/scrollingText";
import { Identifiable, Task as T } from "@planzone/dto";

function List({
  list,
  project,
  resource,
  depth: d,
  isRoot,
  selectedTask,
  toggleTaskSelection,
  toggleListTasks,
}: Props) {
  const depth = d || 0;
  const { pushView } = useModal();
  const { isOpen, toggle } = useToggle(list.uuid, true);
  const { state } = usePreferences();

  const getAllTasksFromList = (list: any): Identifiable<T>[] => {
    let tasks: Identifiable<T>[] = [...list.tasks];
    list.subLists.forEach((subList: any) => {
      tasks = [...tasks, ...getAllTasksFromList(subList)];
    });
    return tasks;
  };

  const isListFullySelected = () => {
    const listTasks = getAllTasksFromList(list);
    return (
      listTasks.length > 0 &&
      listTasks.every((task) => selectedTask.some((t) => t.uuid === task.uuid))
    );
  };

  return (
    <div className={styles.list}>
      {!isRoot && (
        <div className={styles.main}>
          <div
            className={styles.header}
            style={{
              paddingLeft: `${depth === 0 ? 4 : (depth - 1) * 3 + 4}rem`,
            }}
          >
            {(list.subLists.length > 0 || list.tasks.length > 0) && (
              <div className={styles.iconBox} onClick={toggle}>
                <ToggleArrow
                  className={classNames(styles.icon, {
                    [styles.openedIcon]: isOpen,
                  })}
                />
              </div>
            )}
            <div
              className={styles.checkbox}
              onClick={(e) => {
                e.stopPropagation();
                toggleListTasks(list);
              }}
            >
              <Checkbox isChecked={isListFullySelected()} />
            </div>
            <div className={styles.nameContainer}>
              <ScrollingText speed={100}>
                <p
                  className={classNames(styles.name, {
                    [styles.selected]: isListFullySelected(),
                  })}
                  onClick={() =>
                    pushView({
                      key: UseCases.retrieveList,
                      data: { listId: list.uuid },
                    })
                  }
                >
                  {list.name}
                </p>
              </ScrollingText>
            </div>
          </div>
        </div>
      )}
      {(isOpen || isRoot) &&
        list.subLists.map((subList) => (
          <List
            key={subList.uuid}
            list={subList}
            project={project}
            resource={resource}
            depth={depth + 1}
            selectedTask={selectedTask}
            toggleTaskSelection={toggleTaskSelection}
            toggleListTasks={toggleListTasks}
          />
        ))}

      {(isOpen || isRoot) &&
        list.tasks.map((task) => (
          <Task
            key={task.uuid}
            task={task}
            project={project}
            resource={resource}
            depth={depth + 1}
            isChecked={
              selectedTask.find((t) => t.uuid === task.uuid) !== undefined
            }
            toggleTaskSelection={toggleTaskSelection}
          />
        ))}
    </div>
  );
}

export { List };
